import React, { useEffect, useState } from "react";
import MasterLayout from "../masterLayout/MasterLayout";
import Breadcrumb from "../components/Breadcrumb";
import AppointmentTable from "../components/AppointmentTable";

import { Icon } from "@iconify/react/dist/iconify.js";
import { API_URL } from "..";
import { Link, useParams } from "react-router-dom";
import ViewStaffLayer from "./ViewStaffLayer";
const ViewStaffPage = () => {
    const {id} = useParams();
    const [data,setData ]= useState({})
         const fetchAppointments = async () => {
         let headerList = {
           "Accept": "*/*"
        };
        const response = await fetch(
          API_URL+"/api/user/fetch-single/" + id,
          { method: "GET", headers: headerList }
        );
        const data = await response.json();
        if (response.status === 200) {
          setData(data.data);
        }
      };

      useEffect(()=>{
        fetchAppointments()
      },[1])
  return (
    <>

      {/* MasterLayout */}
      <MasterLayout>

        {/* Breadcrumb */}
        <Breadcrumb title="Jobs" />
        <div className="mt-4 mb-20">
        <div className="col-xxl-12">
    
    </div>

        </div>
        {/* TableDataLayer */}
      
        <ViewStaffLayer data={data}/>
      </MasterLayout>

    </>
  );
};

export default ViewStaffPage; 
